import React, { useState, useEffect } from 'react';
import { Table} from 'antd';
import { trainingCoursesColumns, getRowClassName, pageSize,formatTrainingData } from '../util/columnsConfig';
import labels from "../util/labels.json";
import { fetchTrainingPortal } from '../services/Service'; // Adjust the import path as necessary

//import ViewTrainingPortal from './UserView/ViewTrainingPortal';

const TrainingCourses = () => {
  const [dataSource, setDataSource] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const formatTime = ([hours, minutes]) => {
    // Pad single digits with leading zero
    const h = hours.toString().padStart(2, '0');
    const m = minutes.toString().padStart(2, '0');
    return `${h}:${m}`;
  };

 /* useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchTrainingPortal();
       // console.log("API Response:", response);
  
        // ✅ Directly use response since it's already an array
        const formattedData = response.map(item => ({
          key: item.id,
          trainingName: item.trainingName,
          description: item.description,
          trainingStartDate: item.trainingStartDate,
          trainingEndDate: item.trainingEndDate,
          time: `${formatTime(item.startTime)} - ${formatTime(item.endTime)}`, // 👈 Display combined time
          emailId: item.emailId,
          prerequisites: item.prerequisites,
          trainingMode: item.trainingMode,
          certificate: item.certificate,
          trainingType: item.trainingType,
          trainingLink: item.trainingLink
        }));
  
        setDataSource(formattedData);
      } catch (error) {
        console.error("Error fetching training data:", error);
      }
    };
  
    fetchData();
  }, []);*/
  
    useEffect(() => {
        const fetchData = async () => {
          try {
            const response = await fetchTrainingPortal();
            // console.log("API Response:", response);
    
            // Use the formatTrainingData function to format the response data
            const formattedData = formatTrainingData(response);
    
            setDataSource(formattedData);
          } catch (error) {
            console.error("Error fetching training data:", error);
          }
        };
    
        fetchData();
      }, []);
    

  const columns = trainingCoursesColumns(setModalVisible, setSelectedId);

  return (
    
   /* {/* <div className="flex-1 p-1 background-light min-h-screen pt-5">*/
   

       <div className="container mx-auto mt-10 p-5 min-w-full" style={{ height: '80vh', overflow: 'hidden' }}>
   <div className="bg-gray-700 text-white px-4 py-3 rounded-t-md" style={{ backgroundColor: '#1f415b' }}>
        <h2 className="text-lg font-semibold" >{labels.trainingHeader}</h2>
      </div>
     <br></br>
      <Table
        dataSource={dataSource}
        bordered
        
        scroll={{ x: 1100, y: 350 }}
        rowClassName={getRowClassName}
        pagination={{
          pageSize,
          showSizeChanger: false,
          position: ['bottomCenter'],
        }}
        columns={columns.map(col => ({
          ...col,
          onHeaderCell: () => ({
            style: {
              backgroundColor: 'var(--color-primary)',
              color: 'white',
              fontWeight: 'bold',
              position: 'sticky',
              top: 0,
            },
          }),
        }))}
      />
       
       </div>
    
  );
};

export default TrainingCourses;
